import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import authService from "../../services/auth-service";
import BTBox from "../../components/BTBox";
import BTButton from "../../components/BTButton";
import BTInput from "../../components/BTInput";
import DashboardLayout from "../../Layouts/Layoutcontainers";
import EnhancedTable from "../../components/BTTable";
import { Delete, Error } from "@mui/icons-material";
import {
  Card,
  Tooltip,
  Zoom,
  IconButton,
  FormControlLabel,
  Switch,
  TextField,
  Autocomplete,
} from "@mui/material";
import Addreplied from "./Addreplied";
import ConfirmBox from "../../components/ConfirmBox";
import { get_parties, sendMail } from "../../store/functions";
import moment from "moment";
import { fetchData } from "../../utils/fetchData";
import { get } from "../../store/labSlice";
import { useNotification, useLoading } from "../../context";
const default_search = {
  type: 1,
  p_id: null,
  from_date: moment().subtract(1, "month").format("YYYY-MM-DD"),
  to_date: moment().add(1).format("YYYY-MM-DD"),
  rowsPerPage: 50,
  page: 1,
  searchText: null,
  last_id: 0,
  isSub: false,
  p_res_id: null,
};
const CardHeader = ({
  setOpen,
  search,
  setSearch,
  tableType,
  setTableType,
  parties,
  clearState,
}) => {
  const [localDates, setLocalDates] = useState({
    from_date: search?.from_date || "",
    to_date: search?.to_date || "",
  });
  const handleDateChange = (field, value) => {
    const newDates = { ...localDates, [field]: value };
    setLocalDates(newDates);
    const timer = setTimeout(() => {
      clearState();
      setSearch({
        ...search,
        from_date: newDates.from_date,
        to_date: newDates.to_date,
        page: 1,
      });
    }, 500);

    return () => clearTimeout(timer);
  };

  return (
    <Card sx={{ mb: 1 }}>
      <BTBox
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        p={2}
        sx={{
          flexDirection: { xs: "column", sm: "row" },
          alignItems: { xs: "flex-start", sm: "center" },
          gap: 2,
        }}>
        <BTBox
          display="flex"
          alignItems="center"
          sx={{
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 1,
            width: { xs: "100%", sm: "auto" },
          }}>
          <FormControlLabel
            control={
              <Switch
                checked={tableType}
                onChange={() => {
                  clearState();
                  setTableType(!tableType);
                  setSearch({
                    ...default_search,
                    type: tableType ? 1 : 2,
                  });
                }}
                size="small"
                color="secondary"
              />
            }
            label={"All records"}
            labelPlacement="end"
            sx={{
              width: "100%",
              display: "flex",
              alignItems: "center",
            }}
          />
          <BTInput
            size="small"
            type="date"
            label="From Date"
            value={localDates.from_date}
            onChange={(e) => handleDateChange("from_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />

          <BTInput
            size="small"
            type="date"
            label="To Date"
            value={localDates.to_date}
            onChange={(e) => handleDateChange("to_date", e.target.value)}
            variant="standard"
            sx={{ width: "100%" }}
          />
          {tableType && (
            <Autocomplete
              options={parties || []}
              getOptionLabel={(option) =>
                `${option.p_code} : ${option.p_name}` || ""
              }
              renderOption={(props, option) => (
                <li {...props}>{`${option.p_code} : ${option.p_name}`}</li>
              )}
              onChange={(event, value) => {
                clearState();
                setSearch({ ...search, p_id: value?.p_id, page: 1 });
              }}
              sx={{ width: "100%" }}
              value={parties?.find(({ p_id }) => p_id === search?.p_id) || null}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Party"
                  size="small"
                  variant="standard"
                  sx={{ width: { xs: "100%", sm: "200px" } }}
                />
              )}
            />
          )}
        </BTBox>
        <BTBox>
          <BTButton
            variant="gradient"
            size="small"
            fullWidth
            color="dark"
            onClick={() => setOpen({ show: true, actionType: 1 })}
            sx={{ width: { xs: "100%", sm: "auto" } }}>
            Add
          </BTButton>
        </BTBox>
      </BTBox>
    </Card>
  );
};

const ExpandComponent = ({
  row,
  expandColumns,
  clearState,
  reply,
  subRefresh,
}) => {
  const { addNotification } = useNotification();
  const { showLoading, hideLoading } = useLoading();
  const [subRecords, setSubRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState({
    type: 2,
    p_id: null,
    from_date: null,
    to_date: null,
    rowsPerPage: 50000000,
    page: 1,
    searchText: null,
    last_id: 0,
    p_rep_id: row?.rep_id,
  });
  useEffect(() => {
    const localSubs = reply?.filter(
      ({ p_rep_id, rep_type }) => rep_type === 2 && p_rep_id === row?.rep_id
    );
    if (localSubs > 0) {
      setSubRecords(localSubs);
    } else {
      fetchSubs();
    }
  }, [row, reply, subRefresh]);

  const fetchSubs = async () => {
    try {
      const response = await fetchData({
        api: "get_replies",
        name: "reply",
        key: "rep_id",
        searchParams: search,
        filterCallback: null,
        showLoading: () => setLoading(true),
        hideLoading: () => setLoading(false),
        hold: false,
      });

      if (response?.status) {
        setSubRecords(response?.data);
      }
    } finally {
    }
  };
  return (
    <EnhancedTable
      loading={loading}
      rows={subRecords}
      columns={expandColumns}
      title="Replies Details"
      tableHeader={true}
      checkBoxSelected={true}
      onDeleteSelected={(pcs) =>
        sendMail({
          pcs,
          type: "reply",
          notification: addNotification,
          showLoading,
          hideLoading,
        })
      }
      selectedConfiguration={{
        bgColor: "white",
        buttons: [
          <BTButton
            color={"dark"}
            variant={"gradient"}
            size="small"
            fullWidth
            sx={{ width: "150px" }}>
            Send mail
          </BTButton>,
        ],
      }}
    />
  );
};

const ReadyForReturn = () => {
  const { addNotification } = useNotification();
  const { showLoading, hideLoading } = useLoading();
  const dispatch = useDispatch();
  const parties = useSelector((state) => state?.lab?.parties);
  const reply = useSelector((state) => state?.lab?.reply);
  const [open, setOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [subRefresh, setSubRefresh] = useState(false);
  const [tableType, setTableType] = useState(false);
  const [search, setSearch] = useState(default_search);
  let pageIndex = reply?.pages?.findIndex((p) => p.page === search.page);
  const startIndex = pageIndex !== -1 ? pageIndex * search.rowsPerPage : 0;
  const endIndex = startIndex + search.rowsPerPage;
  useEffect(() => {
    !parties?.is_fetch && get_parties();
  }, []);
  useEffect(() => {
    fetchReplies();
  }, [search]);

  const handleSearch = (data, searchData) => {
    const filterBySearch = data?.filter((item) => {
      const searchText = searchData?.searchText?.toLowerCase().trim() || "";
      const matchText =
        !searchText?.trim() ||
        String(item?.report_number)?.includes(searchText) ||
        String(item.customer_ref_no)?.includes(searchText) ||
        String(item?.shape_name)?.includes(searchText) ||
        String(item?.description)?.includes(searchText);
      const matchFilters =
        item?.rep_type === searchData?.type &&
        (searchData?.p_id ? item?.p_id === searchData?.p_id : true) &&
        moment(item.rep_date, "YYYY-MM-DD").isBetween(
          moment(searchData?.from_date, "YYYY-MM-DD").startOf("day"),
          moment(searchData?.to_date, "YYYY-MM-DD").endOf("day"),
          null,
          "[]"
        );
      return matchText && matchFilters;
    });
    const paginateData = filterBySearch?.slice(startIndex, endIndex);
    return paginateData;
  };
  const fetchReplies = async () => {
    await fetchData({
      api: "get_replies",
      name: "reply",
      key: "rep_id",
      searchParams: search,
      filterCallback: handleSearch,
      showLoading: () => setLoading(true),
      hideLoading: () => setLoading(false),
      hold: true,
    });
  };

  const clearState = () => {
    dispatch(
      get({
        name: "reply",
        data: [],
        pages: [],
        total: 0,
        fetch: false,
      })
    );
  };

  // columns
  const expandColumns = [
    {
      id: "id",
      name: "ID",
      value: (row) => row?.rep_id,
      selector: (row, index) => index + 1,
      width: "50px",
    },
    {
      id: "report_date",
      name: "Report Date",
      selector: (row) => row.report_date,
      sortable: true,
    },
    {
      id: "stn_date",
      name: "Submission Date",
      selector: (row) =>
        moment(row?.stn_date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      sortable: true,
    },
    {
      id: "rep_date",
      name: "Reply date",
      selector: (row) =>
        moment(row?.rep_date, "YYYY-MM-DD").format("DD/MM/YYYY"),
      sortable: true,
    },

    {
      id: "report_number",
      name: "Report Number",
      selector: (row) => row.report_number,
      sortable: true,
    },
    {
      id: "p_name",
      name: "Party",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_name;
      },
      sortable: true,
    },
    {
      id: "p_code",
      name: "Party code",
      selector: (row) => {
        const party = parties?.data?.find(({ p_id }) => p_id === row?.p_id);
        return party?.p_code;
      },
      sortable: true,
    },
    {
      id: "shape_name",
      name: "Shape Name",
      selector: (row) => row.shape_name,
      sortable: true,
    },
    {
      id: "weight",
      name: "Weight",
      selector: (row) => row.weight,
      sortable: true,
    },
    {
      id: "description",
      name: "Description",
      selector: (row) => row.description,
      sortable: true,
    },
    {
      id: "pol_or_pol_sym",
      name: "POL or Pol/Sym",
      selector: (row) => row.pol_or_pol_sym,
      sortable: true,
    },
    {
      id: "sym",
      name: "SYM",
      selector: (row) => row.sym,
      sortable: true,
    },
    {
      id: "cut_prop",
      name: "CUT-PROP",
      selector: (row) => row.cut_prop,
      sortable: true,
    },
    {
      id: "clarity",
      name: "Clarity",
      selector: (row) => row.clarity,
      sortable: true,
    },
    {
      id: "fluorescence",
      name: "Fluorescence",
      selector: (row) => row.fluorescence,
      sortable: true,
    },
    {
      id: "stn_prefix_ref_no",
      name: "Prefix No",
      selector: (row) => row?.stn_prefix_ref_no,
      sortable: true,
    },
    {
      id: "customer_ref_no",
      name: "Customer Ref No.",
      selector: (row) => row.customer_ref_no,
      sortable: true,
    },
    {
      id: "laserscribe",
      name: "Laserscribe",
      selector: (row) => row.laserscribe,
      sortableL: true,
    },
    {
      id: "recheck",
      name: "Recheck",
      selector: (row) => row.recheck,
    },

    // {
    //   id: "actions",
    //   name: "Actions",
    //   value: () => "",
    //   selector: (row) => (
    //     <Tooltip title="Delete" TransitionComponent={Zoom}>
    //       <IconButton
    //         size="small"
    //         onClick={() => {
    //           const checkValid = labouts?.data?.find(
    //             ({ report_number }) => report_number === row?.report_number
    //           );
    //           if (checkValid) {
    //             addNotification({
    //               icon: <Error color="white" />,
    //               title: "Error",
    //               message:
    //                 "Deletion is not allowed as this record is referenced in the labout records.",
    //               color: "error",
    //             });
    //             return;
    //           }
    //           setDelete(row);
    //         }}
    //       >
    //         <Delete fontSize="12px" color="error" />
    //       </IconButton>
    //     </Tooltip>
    //   ),
    //   width: "50px",
    //   bodyCellStyle: {
    //     padding: "0px",
    //   },
    // },
  ];
  const columns = [
    {
      id: "id",
      name: "ID",
      selector: (row, index) => index + 1,
      width: "50px",
      numeric: false,
      sortable: true,
    },
    {
      id: "sub_count",
      name: "Number of Stones",
      selector: (row) => row?.number_stones,
      sortable: true,
    },
    {
      id: "sub_weight",
      name: "Weight",
      selector: (row) => row?.weight?.toFixed(2),
      sortable: true,
    },
    {
      id: "rep_date",
      name: "Date",
      selector: (row) =>
        moment(row?.rep_date, "YYYY-MM-DD HH:mm:ss").format("DD/MM/YYYY"),
      sortable: true,
    },
    // {
    //   id: "actions",
    //   name: "Actions",
    //   value: () => "",
    //   selector: (row) => (
    //     <Tooltip title="Delete" TransitionComponent={Zoom}>
    //       <IconButton
    //         size="small"
    //         onClick={() => {
    //           const data = replies?.data?.filter(
    //             ({ p_rep_id }) => p_rep_id === row?.rep_id
    //           );
    //           if (data?.length > 0) {
    //             addNotification({
    //               icon: <Error color="white" />,
    //               title: "Error",
    //               message:
    //                 "Deletion is not allowed as this record includes a sub-replies.",
    //               color: "error",
    //             });
    //             return;
    //           }
    //           setDelete(row);
    //         }}
    //       >
    //         <Delete fontSize="12px" color="error" />
    //       </IconButton>
    //     </Tooltip>
    //   ),
    //   width: "50px",
    //   center: true,
    //   bodyCellStyle: {
    //     padding: "0px",
    //   },
    // },
  ];

  const renderData = reply?.data?.filter(
    ({ rep_type }) => rep_type === search?.type
  );

  return (
    <DashboardLayout>
      <CardHeader
        search={search}
        setSearch={setSearch}
        setOpen={setOpen}
        parties={parties?.data}
        clearState={clearState}
        tableType={tableType}
        setTableType={setTableType}
      />
      <EnhancedTable
        columns={tableType ? expandColumns : columns}
        loading={loading}
        tableHeader={true}
        rows={renderData?.slice(startIndex, endIndex)}
        title="Replies"
        defaultSort="carbs"
        pagination={true}
        expandComponent={
          <ExpandComponent
            expandColumns={expandColumns}
            reply={reply?.data}
            subRefresh={subRefresh}
            clearState={clearState}
          />
        }
        serverSidePagination={true}
        serverSideSearch={true}
        totalRows={reply?.total}
        onPageChange={({ page, rowsPerPage, searchText }) => {
          if (search?.rowsPerPage !== rowsPerPage) {
            clearState();
          }
          setSearch({
            ...search,
            page,
            rowsPerPage,
            searchText,
            last_id: reply?.pages[pageIndex]?.next_last_id,
          });
        }}
        onSearchChange={(searchText, { page, rowsPerPage }) => {
          clearState();
          setSearch((prev) => ({ ...prev, searchText, page, rowsPerPage }));
        }}
        initialPage={search?.page}
        expandRow={tableType ? false : true}
        checkBoxSelected={tableType ? true : false}
        fetchData={{
          fnc: fetchData,
          params: {
            api: "get_replies",
            searchParams: {
              ...search,
              page: 1,
              rowsPerPage: reply?.total,
            },
            filterCallback: null,
            name: "reply",
            key: "rep_id",
            showLoading,
            hideLoading,
            hold: false,
          },
        }}
        onDeleteSelected={(pcs) =>
          sendMail({
            pcs,
            type: "reply",
            notification: addNotification,
            showLoading,
            hideLoading,
          })
        }
        selectedConfiguration={{
          bgColor: "white",
          buttons: [
            <BTButton
              color={"dark"}
              variant={"gradient"}
              size="small"
              fullWidth
              sx={{ width: "150px" }}>
              Send mail
            </BTButton>,
          ],
        }}
      />
      {Boolean(open) && (
        <Addreplied open={open} setOpen={setOpen} type={tableType} />
      )}
      {/* {Boolean(isDelete) && (
        <ConfirmBox
          setDelete={setDelete}
          row={isDelete}
          name="replies"
          id="rep_id"
          service={authService?.delete_reply}
        />
      )} */}
    </DashboardLayout>
  );
};
export default ReadyForReturn;
